import { Http, Response } from "@angular/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
  SERVICE_URLS, ITCIApplicationAuditRecords
} from "@tci/common";
import { NgAppChangeNotificationService } from "../../../ng-shared/ng-services/ng-app-change-notification.service";

@Injectable()
export class BaseAppDetailHistoryService {
  constructor(
    private http: Http,
    private appRefreshNotifSvc: NgAppChangeNotificationService
  ) { }

  public getApplicationHistory(appId: string): Observable<ITCIApplicationAuditRecords> {
    const url = `${SERVICE_URLS.APPS}/audits/${appId}`;
    return this
      .http
      .get(url)
      .map((res: Response) => res.json() || null)
      .catch(error => {
        console.log(error);
        throw error;
      });
  }

  // Share the app refresh notification subject
  getAppRefreshNotifSubj() {
    return this.appRefreshNotifSvc.getRefreshSubject();
  }
}
